import baseRoutes from '@/BaseRoutes'
import LatestPostsTV from '@/views/LatestPostsTV'

const customerRoutes = [
  {
    path: '/:lang/bubbletool_tv',
    name: 'bubbletool-tv',
    component: LatestPostsTV,
    meta: { requiresAuth: false, bodyClass: 'latest_post_tv' },
  },
]
export default customerRoutes.concat(baseRoutes)

export const customerBeforeEach = []
